<template>
  <div :class="$style.container">
    <LoadingOverlay :visible="showLoader" />
    <Card
      v-if="showDetails"
      :hasNoBorder="true"
    >
      <HeadingSmall hasMargin>
        {{ item.displayName }} - Results Log
      </HeadingSmall>
      <ParagraphBody>
        Policy Applied to <b>{{ item.displayName }}</b>
      </ParagraphBody>
      <CopyWell
        :class="$style.copyWellFull"
        label="JSON:"
        :multiLine="true"
        :value="policyResults"
      />
    </Card>
  </div>
</template>

<script>
import {
  Card,
  CopyWell,
  HeadingSmall,
  LoadingOverlay,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import GoogleMdmApi from 'client/api/v2/GoogleMdmApi';

const systemModel = StoreModelMap[ItemTypeConsts.device];

export default {
  name: 'AndroidPolicyResults',

  components: {
    Card,
    CopyWell,
    HeadingSmall,
    LoadingOverlay,
    ParagraphBody,
  },

  data: () => ({
    policyResults: '',
    showDetails: false,
    showLoader: true,
  }),

  computed: {
    ...mapState(systemModel, [
      'item',
    ]),
  },

  mounted() {
    this.fetchPolicyResults();
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
    ]),
    async fetchPolicyResults() {
      try {
        const devicePolicyResults = await GoogleMdmApi.getPolicyResults(
          this.item.mdm.internal.deviceId,
        );
        this.policyResults = JSON.stringify(
          JSON.parse(String(devicePolicyResults.policy)), null, 2,
        );
        this.showLoader = false;
        this.showDetails = true;
      } catch (err) {
        this.triggerErrorNotification({
          message: 'Unable to fetch Policy Results for this device',
          showCloseButton: true,
          icon: 'error',
        });
        this.showLoader = false;
      }
    },
  },
};
</script>

<style module scoped>
.container {
  height: 100%;
  overflow: auto;
  padding: 0.625rem 1.25rem 0.625rem;
  width: 100%;
}

.copyWellFull {
  width: 100%;
}
</style>
